import(/* webpackMode: "eager" */ "/vercel/path0/app/resources/case-studies/retail-ecommerce/page.tsx");
